import React from "react";
import {
  IconButton as MUIButton,
  SvgIcon,
  Badge,
  Tooltip,
} from "@mui/material";
import "./IconButton.scss";

const IconButton = ({
  icon,
  imageSrc,
  onClick,
  badgeContent,
  className = "",
  isActive = false,
  title,
  ...props
}) => {
  const buttonContent = imageSrc ? (
    <SvgIcon component={imageSrc} inheritViewBox />
  ) : (
    icon
  );

  const button = (
    <Tooltip
      title={title || ""}
      slotProps={{ tooltip: { className: "button-tooltip" } }}
    >
      <span>
        <MUIButton
          onClick={onClick}
          className={`icon-button ${
            isActive ? "temActive" : ""
          } ${className}`.trim()}
          aria-pressed={isActive ? true : undefined}
          {...props}
        >
          {buttonContent}
        </MUIButton>
      </span>
    </Tooltip>
  );

  return badgeContent != null ? (
    <Badge badgeContent={badgeContent}>{button}</Badge>
  ) : (
    button
  );
};

export default IconButton;
